import { twMerge } from 'tailwind-merge';
import Title from '@/components/Title';
import { InvestorIcon } from '@/icons';
import Card from '@/components/Card';
import { formatNumber } from '@/utils/strings';
import { classes } from '../utils';

export type InvestorsCardProps = {
  className?: string;
  count: number;
};

export default function InvestorsCard({
  className,
  count,
}: InvestorsCardProps) {
  return (
    <Card className={twMerge(classes.card, className)}>
      <div className={classes.textWrapper}>
        <div className={classes.label}>Investors</div>
        <Title size="md">{formatNumber(count)}</Title>
      </div>
      <div className={twMerge(classes.icon, classes.investorIcon)}>
        <InvestorIcon />
      </div>
    </Card>
  );
}
